import { render, staticRenderFns } from "./CopyToClipboardTooltip.vue?vue&type=template&id=298b43d0&scoped=true"
import script from "./CopyToClipboardTooltip.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardTooltip.vue?vue&type=script&lang=js"
import style0 from "./CopyToClipboardTooltip.vue?vue&type=style&index=0&id=298b43d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b43d0",
  null
  
)

export default component.exports